(function () {
  'use strict';
  var root = document.querySelector('[data-rb-upsell]');
  var rules = window.RBUpsellRules;
  if (!root || !rules || typeof HTMLDialogElement === 'undefined' || !window.fetch) return;
  var config;
  try { config = JSON.parse(root.querySelector('[data-rb-upsell-config]').textContent); } catch (error) { return; }
  var dialog = root.querySelector('dialog');
  var heading = dialog.querySelector('h2');
  if (heading) {
    heading.tabIndex = -1;
    heading.setAttribute('autofocus', '');
    heading.style.outline = 'none';
  }
  var list = root.querySelector('[data-rb-upsell-list]');
  var status = root.querySelector('[data-rb-upsell-status]');
  var total = root.querySelector('[data-rb-upsell-total]');
  var intro = root.querySelector('[data-rb-upsell-intro]');
  var basketLink = root.querySelector('.rb-upsell-basket-link');
  var keepShopping = root.querySelector('.rb-upsell-keep-shopping');
  var basketHref = basketLink.getAttribute('href');
  var cart = null;
  var opener = null;
  var busy = false;
  var uncertain = false;
  var qualificationLost = false;
  var inMemoryCount = 0;
  var inMemoryParents = [];
  var storageKey = 'rb-upsell-appearances-v1';
  var parentsStorageKey = 'rb-upsell-seen-parents-v1';
  var operationDeadline = 0;
  var offers = [];
  root.querySelectorAll('template[data-rb-upsell-row]').forEach(function (template) {
    var node = template.content.firstElementChild;
    offers.push({
      productId: node.dataset.productId,
      variantId: node.dataset.variantId,
      price: Number(node.dataset.price),
      kind: node.dataset.kind,
      available: true,
      template: template
    });
  });
  function appearances() {
    try { return Math.max(inMemoryCount, Number(sessionStorage.getItem(storageKey)) || 0); } catch (error) { return inMemoryCount; }
  }
  function seenParents() {
    try {
      var saved = JSON.parse(sessionStorage.getItem(parentsStorageKey) || '[]');
      if (Array.isArray(saved)) return Array.from(new Set(inMemoryParents.concat(saved.filter(function (id) { return typeof id === 'string'; }))));
    } catch (error) { }
    return inMemoryParents;
  }
  function recordAppearance() {
    inMemoryCount = appearances() + 1;
    inMemoryParents = Array.from(new Set(seenParents().concat(String(config.parentId))));
    try {
      sessionStorage.setItem(storageKey, String(inMemoryCount));
      sessionStorage.setItem(parentsStorageKey, JSON.stringify(inMemoryParents));
    } catch (error) { }
  }
  function text(key) { return (config.text[key] || '').replace(/&#39;/g, "'").replace(/&quot;/g, '"').replace(/&amp;/g, '&'); }
  function money(cents) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: 'GBP' }).format(cents / 100);
  }
  function translate(key, value) { return text(key).replace('[amount]', value); }
  function cartCurrencyValid(value) { return value && value.currency === 'GBP' && Array.isArray(value.items); }
  function announce(message) { status.textContent = message; }
  function updatePrices() {
    var active = !qualificationLost && rules.promotionActive(config);
    intro.textContent = active ? text(config.kind === 'straw' ? 'introStraw' : 'introOffer') : text('introStandard');
    var hasAddedExtra = Array.prototype.some.call(list.querySelectorAll('[data-rb-upsell-offer]'), function (row) { return row.querySelector('button').dataset.added === 'true'; });
    keepShopping.textContent = text(hasAddedExtra ? 'keepShopping' : 'declineExtras');
    list.querySelectorAll('[data-rb-upsell-offer]').forEach(function (row) {
      var offer = offers.find(function (item) { return item.productId === row.dataset.productId; });
      var amount = row.querySelector('input');
      var priced = rules.displayedPrice(offer, amount.value, cart, config);
      if (row.querySelector('button').dataset.added === 'true') {
        priced = rules.nativeAddedPrice(cart, offer.variantId, 'extras-v1-' + config.parentId + '-' + offer.productId) || priced;
      }
      row.querySelector('[data-rb-upsell-price]').textContent = money(priced.total);
      var original = row.querySelector('s');
      original.hidden = !priced.saving;
      original.textContent = money(priced.original);
      var badge = row.querySelector('[data-rb-upsell-saving]');
      badge.hidden = !priced.saving;
      badge.textContent = translate('saving', money(priced.saving));
    });
    if (cartCurrencyValid(cart)) total.textContent = translate('basketTotal', money(cart.total_price));
  }
  function close() {
    if (busy) { announce(text('adding')); return; }
    if (dialog.open) dialog.close();
  }
  dialog.addEventListener('cancel', function (event) {
    if (busy) { event.preventDefault(); announce(text('adding')); }
  });
  basketLink.addEventListener('click', function (event) {
    if (busy) { event.preventDefault(); announce(text('adding')); }
  });
  dialog.addEventListener('close', function () {
    document.body.classList.remove('rb-upsell-open');
    if (opener && opener.isConnected) opener.focus();
  });
  dialog.addEventListener('click', function (event) {
    if (event.target === dialog) close();
  });
  root.querySelectorAll('[data-rb-upsell-close]').forEach(function (button) { button.addEventListener('click', close); });
  dialog.addEventListener('keydown', function (event) {
    if (event.key !== 'Tab') return;
    var focusable = Array.prototype.filter.call(dialog.querySelectorAll('button:not(:disabled),a[href],input:not(:disabled)'), function (el) { return !el.hidden && el.getClientRects().length; });
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (!first || !last) return;
    if (heading && document.activeElement === heading) {
      event.preventDefault();
      (event.shiftKey ? last : first).focus();
    } else if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  function request(url, options, readJson) {
    return new Promise(function (resolve, reject) {
      var remaining = operationDeadline - Date.now();
      if (remaining <= 0) { reject(new Error('operation_timeout')); return; }
      var settled = false;
      var controller = typeof AbortController === 'undefined' ? null : new AbortController();
      if (controller) options.signal = controller.signal;
      var timer = setTimeout(function () {
        if (settled) return;
        settled = true;
        if (controller) controller.abort();
        reject(new Error('request_timeout'));
      }, Math.min(8000, remaining));
      Promise.resolve().then(function () { return fetch(url, options); }).then(function (response) {
        if (!readJson) return response;
        if (!response.ok) throw new Error('cart_read');
        return response.json();
      }).then(function (value) {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        resolve(value);
      }, function (error) {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        reject(error);
      });
    });
  }
  function readCart() {
    return request(config.cartUrl + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' }, cache: 'no-store' }, true).then(function (value) {
      if (!cartCurrencyValid(value)) throw new Error('cart_currency');
      return value;
    });
  }
  function setBusy(value) {
    busy = value;
    dialog.setAttribute('aria-busy', String(value));
    list.querySelectorAll('input,button').forEach(function (el) {
      el.disabled = value || uncertain || qualificationLost || el.dataset.added === 'true';
    });
    root.querySelectorAll('[data-rb-upsell-close]').forEach(function (el) { el.disabled = value; });
    if (value) {
      basketLink.removeAttribute('href');
      basketLink.setAttribute('aria-disabled', 'true');
      basketLink.setAttribute('tabindex', '-1');
    } else {
      basketLink.setAttribute('href', basketHref);
      basketLink.removeAttribute('aria-disabled');
      basketLink.removeAttribute('tabindex');
    }
  }
  function cartUpdated(value) {
    cart = value;
    window.dispatchEvent(new CustomEvent('cartcount:update', { detail: value }));
    updatePrices();
  }
  function markAdded(row, amount) {
    row.querySelector('input').value = String(amount);
    row.querySelectorAll('input,button').forEach(function (el) { el.dataset.added = 'true'; el.disabled = true; });
    var button = row.querySelector('button');
    button.textContent = text('added');
    button.setAttribute('aria-label', text('added') + ' ' + row.querySelector('h3').textContent);
    announce(translate('addedQuantity', String(amount)));
    updatePrices();
  }
  function addOffer(row) {
    if (busy || uncertain || qualificationLost || row.querySelector('button').dataset.added === 'true') return;
    var offer = offers.find(function (item) { return item.productId === row.dataset.productId; });
    var input = row.querySelector('input');
    if (!rules.validQuantity(input.value) || !input.checkValidity()) { input.reportValidity(); return; }
    var amount = Number(input.value);
    operationDeadline = Date.now() + 20000;
    setBusy(true);
    announce(text('adding'));
    var before;
    var explicitRefusal = false;
    var postStarted = false;
    var code = 'extras-v1-' + config.parentId + '-' + offer.productId;
    readCart().then(function (fresh) {
      if (!rules.parentPresent(fresh, config.parentId)) {
        qualificationLost = true;
        cartUpdated(fresh);
        throw new Error('qualification_lost');
      }
      cartUpdated(fresh);
      if (!rules.filterOffers([offer], fresh, config.parentId, config.components).length) throw new Error('already_present');
      before = rules.variantQuantity(fresh, offer.variantId, code);
      postStarted = true;
      return request(config.addUrl + '.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(offer.variantId), quantity: amount, properties: { _rb_upsell_offer: code, _rb_upsell_placement: 'product-confirmed-add' } }] })
      });
    }).then(function (response) {
      explicitRefusal = response.status >= 400 && response.status < 500;
      if (!response.ok) throw new Error('add_response');
      return readCart();
    }).then(function (fresh) {
      cartUpdated(fresh);
      var result = rules.reconcileAddition(before, rules.variantQuantity(fresh, offer.variantId, code), amount, false);
      if (result.state === 'added') markAdded(row, result.added);
      else if (result.state === 'partial') { markAdded(row, result.added); announce(text('partial')); }
      else { uncertain = true; announce(text('uncertain')); }
    }).catch(function (error) {
      if (!postStarted) {
        announce(error.message === 'qualification_lost' ? text('qualificationLost') : error.message === 'already_present' ? text('alreadyPresent') : text('readFailed'));
        return;
      }
      return readCart().then(function (fresh) {
        cartUpdated(fresh);
        var result = rules.reconcileAddition(before, rules.variantQuantity(fresh, offer.variantId, code), amount, explicitRefusal);
        if (result.state === 'added') markAdded(row, result.added);
        else if (result.state === 'partial') { markAdded(row, result.added); announce(text('partial')); }
        else if (result.retrySafe) announce(text('refused'));
        else { uncertain = true; announce(text('uncertain')); }
      }).catch(function () { uncertain = true; announce(text('uncertain')); });
    }).finally(function () { operationDeadline = 0; setBusy(false); });
  }
  list.addEventListener('input', function (event) {
    if (event.target.matches('input')) updatePrices();
  });
  list.addEventListener('click', function (event) {
    var button = event.target.closest('[data-rb-upsell-add]');
    if (button) addOffer(button.closest('[data-rb-upsell-offer]'));
  });
  window.RustyBarrelUpsell = {
    afterConfirmedAdd: function (event) {
      if (busy || uncertain || dialog.open || !rules.canShowAutomatically(appearances(), seenParents(), config.parentId) || !event || !event.item || String(event.item.product_id) !== String(config.parentId) || !event.button || !event.button.closest('[data-product-wrapper]') || !cartCurrencyValid(event.cart) || config.currency !== 'GBP' || !rules.parentPresent(event.cart, config.parentId)) return false;
      var available = rules.selectOffers(offers, event.cart, config.parentId, config.components);
      if (!available.length) return false;
      list.replaceChildren();
      available.forEach(function (offer) { list.appendChild(offer.template.content.cloneNode(true)); });
      cart = event.cart;
      opener = event.button;
      uncertain = false;
      qualificationLost = false;
      announce('');
      updatePrices();
      try { dialog.showModal(); } catch (error) { return false; }
      document.dispatchEvent(new Event('closeFlyouts'));
      document.body.classList.add('rb-upsell-open');
      recordAppearance();
      (heading || root.querySelector('[data-rb-upsell-close]')).focus({ preventScroll: true });
      return true;
    }
  };
  var reset = root.querySelector('[data-rb-upsell-reset]');
  if (reset) reset.addEventListener('click', function () {
    inMemoryCount = 0;
    inMemoryParents = [];
    try { sessionStorage.removeItem(storageKey); sessionStorage.removeItem(parentsStorageKey); } catch (error) { }
    reset.textContent = text('resetDone');
  });
  if ((config.priceMode === 'live' || config.priceMode === 'customer_test') && Number.isFinite(Date.parse(config.testUntil))) {
    var expiryDelay = Date.parse(config.testUntil) - Date.now();
    if (expiryDelay > 0 && expiryDelay < 2147483600) setTimeout(updatePrices, expiryDelay + 50);
  }
  root.dataset.rbUpsellReady = 'true';
}());
